import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../../context";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import moment from "moment";

const MerchantWasteDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [wasteDetailsList, setWasteDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [totalCost, setTotalCost] = useState(0);
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Price x Quantity",
      align: "right",
      render: (text, record) => (
        <p>
          &#8369;{text.price} x {text.quantity}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantWasteDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
    };
    axios
      .get("user/merchant/spec/waste-transaction-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setWasteDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      // total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
      total +=
        parseInt(data[i].is_per_piece) === 1
          ? parseFloat(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  useEffect(() => {
    getMerchantWasteDetails();
  }, [getMerchantWasteDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Waste Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                style={{
                  //  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Transaction Date:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {wasteDetailsList.ready &&
                    moment(
                      new Date(wasteDetailsList.data[0].transaction_date)
                    ).format("LLL")}
                </span>
              </Typography>

              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: 14,
                  textTransform: "capitalize",
                  // marginBottom: 10,
                }}
              >
                Transaction #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {wasteDetailsList.ready &&
                    wasteDetailsList.data[0].transaction_id}
                </span>
              </Typography>

              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: 14,
                  textTransform: "capitalize",
                  marginBottom: 10,
                }}
              >
                Employee:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {wasteDetailsList.ready &&
                    wasteDetailsList.data[0].wasteemployeeinfo.firstname}
                  ,{" "}
                  {wasteDetailsList.ready &&
                    wasteDetailsList.data[0].wasteemployeeinfo.lastname}
                </span>
              </Typography>
            </div>

            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                wasteDetailsList.data.length > 0 ? wasteDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.id}
            />
            <div style={{ display: "flex", padding: 15 }}>
              <div style={{ flexGrow: 1 }} />
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                Total: &#8369;
                {totalCost.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
          </div>
        </>
      )}

      {/* <Button
        type="primary"
        onClick={handlePrint}
        icon={<PrinterOutlined />}
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
      >
        Print
      </Button> */}
    </Drawer>
  );
};

export default MerchantWasteDetails;
